export const lottieLoaderJson = {
    "v": "5.9.0",
    "fr": 60,
    "ip": 0,
    "op": 605,
    "w": 107,
    "h": 107,
    "nm": "Fjord Line Loader anim",
    "ddd": 0,
    "assets": [
        {
            "id": "comp_0",
            "nm": "Mask",
            "fr": 60,
            "layers": [
                {
                    "ddd": 0,
                    "ind": 1,
                    "ty": 4,
                    "nm": "Boat and water",
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [58.5, 53.25, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": { "a": 0, "k": [303, 106.5], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 4 },
                            "nm": "Rectangle Path 1",
                            "mn": "ADBE Vector Shape - Rect",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 2,
                    "ty": 4,
                    "nm": "Ellipse 1",
                    "parent": 1,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [17.5, -25.25, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "d": 1,
                                    "ty": "el",
                                    "s": { "a": 0, "k": [18, 18], "ix": 2 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "nm": "Ellipse Path 1",
                                    "mn": "ADBE Vector Shape - Ellipse",
                                    "hd": false
                                },
                                {
                                    "ty": "op",
                                    "nm": "Offset Paths 1",
                                    "a": { "a": 0, "k": -0.5, "ix": 1 },
                                    "lj": 1,
                                    "ml": { "a": 0, "k": 4, "ix": 3 },
                                    "ix": 3,
                                    "mn": "ADBE Vector Filter - Offset",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Ellipse 1 Stroke",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "d": 1,
                                    "ty": "el",
                                    "s": { "a": 0, "k": [18, 18], "ix": 2 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "nm": "Ellipse Path 1",
                                    "mn": "ADBE Vector Shape - Ellipse",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0.988235294118, 0.729411764706, 0.188235294118, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Ellipse 1 Fill",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 3,
                    "ty": 4,
                    "nm": "Water",
                    "parent": 1,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.167, "y": 0.167 },
                                    "t": 0,
                                    "s": [80.833, 30, 0],
                                    "to": [-30.167, 0, 0],
                                    "ti": [30.167, 0, 0]
                                },
                                { "t": 594, "s": [-100.167, 30, 0] }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": { "a": 0, "k": [303, 46.5], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 4 },
                            "nm": "Rectangle Path 1",
                            "mn": "ADBE Vector Shape - Rect",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 4,
                    "ty": 4,
                    "nm": "Path 24",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [120.5, 15, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.25, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.265, 0],
                                                [2.388, 2.27],
                                                [0.257, 0],
                                                [0.186, -0.177],
                                                [1.598, -0.602],
                                                [1.707, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.127, 0.054],
                                                [0.139, 0],
                                                [0.128, -0.054],
                                                [0.096, -0.099],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.057],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.095, -0.1],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.187, -0.188],
                                                [0, -0.265],
                                                [0, 0],
                                                [-0.188, -0.188],
                                                [-0.265, 0],
                                                [0, 0],
                                                [-0.187, 0.188],
                                                [0, 0.265],
                                                [0, 0],
                                                [0.188, 0.188]
                                            ],
                                            "o": [
                                                [-3.295, 0.014],
                                                [-0.186, -0.177],
                                                [-0.256, 0],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.706, -0.061],
                                                [-1.551, -0.715],
                                                [-0.096, -0.099],
                                                [-0.128, -0.054],
                                                [-0.138, 0],
                                                [-0.127, 0.054],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.001],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.265, 0],
                                                [-0.188, 0.188],
                                                [0, 0],
                                                [0, 0.265],
                                                [0.187, 0.188],
                                                [0, 0],
                                                [0.265, 0],
                                                [0.188, -0.188],
                                                [0, 0],
                                                [0, -0.265],
                                                [-0.187, -0.188]
                                            ],
                                            "v": [
                                                [61, 4.5],
                                                [52.144, 0.985],
                                                [51.454, 0.71],
                                                [50.765, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.084, 0.096],
                                                [31.681, 0.015],
                                                [31.279, 0.096],
                                                [30.941, 0.328],
                                                [26.636, 3.412],
                                                [21.455, 4.501],
                                                [16.273, 3.412],
                                                [11.968, 0.328],
                                                [11.637, 0.088],
                                                [11.237, 0],
                                                [10.835, 0.08],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.293, 4.793],
                                                [0, 5.5],
                                                [0, 15.5],
                                                [0.293, 16.208],
                                                [1, 16.5],
                                                [61, 16.5],
                                                [61.707, 16.208],
                                                [62, 15.5],
                                                [62, 5.5],
                                                [61.707, 4.793]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 24",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 5,
                    "ty": 4,
                    "nm": "Path 23",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [120.5, -14.929, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [-1.259, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.698, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.509, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.377, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.046],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [3.295, 0.014],
                                                [1.634, 0.718],
                                                [1.204, 1.317],
                                                [0.128, 0.056],
                                                [0.14, 0],
                                                [0.127, -0.056],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0],
                                                [-0.338, 0.004]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.217],
                                                [0, 0],
                                                [1.034, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.366, 0],
                                                [1.25, -0.549],
                                                [0.377, -0.409],
                                                [0.51, -0.223],
                                                [0.556, 0],
                                                [0.509, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.047],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-2.388, 2.27],
                                                [-1.785, 0.003],
                                                [-1.634, -0.718],
                                                [-0.094, -0.103],
                                                [-0.127, -0.056],
                                                [-0.139, 0],
                                                [-0.128, 0.056],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.056],
                                                [-0.138, -0.003],
                                                [-0.128, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.12, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.679, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.49],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [41.909, 4.5],
                                                [36.725, 3.416],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.681, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.455, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.834, 0.078],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642],
                                                [1, 16.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 23",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 6,
                    "ty": 4,
                    "nm": "Path 22",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [120.5, 0.071, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.338, 0.004],
                                                [-1.259, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.698, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.509, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.377, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.047],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [1.598, -0.602],
                                                [1.706, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.128, 0.057],
                                                [0.14, 0],
                                                [0.127, -0.057],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.128, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.218],
                                                [0, 0],
                                                [1.034, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.366, 0],
                                                [1.25, -0.549],
                                                [0.377, -0.409],
                                                [0.51, -0.223],
                                                [0.556, 0],
                                                [0.509, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.046],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.707, -0.061],
                                                [-1.551, -0.715],
                                                [-0.094, -0.103],
                                                [-0.127, -0.057],
                                                [-0.139, 0],
                                                [-0.128, 0.057],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.003],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.12, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.679, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.491],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.681, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.455, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.833, 0.077],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 22",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 7,
                    "ty": 4,
                    "nm": "Path 21",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [60.5, 15, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.25, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.265, 0],
                                                [2.388, 2.27],
                                                [0.257, 0],
                                                [0.186, -0.177],
                                                [1.598, -0.602],
                                                [1.707, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.127, 0.054],
                                                [0.139, 0],
                                                [0.128, -0.054],
                                                [0.096, -0.099],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.057],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.095, -0.1],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.187, -0.188],
                                                [0, -0.265],
                                                [0, 0],
                                                [-0.188, -0.188],
                                                [-0.265, 0],
                                                [0, 0],
                                                [-0.187, 0.188],
                                                [0, 0.265],
                                                [0, 0],
                                                [0.188, 0.188]
                                            ],
                                            "o": [
                                                [-3.295, 0.014],
                                                [-0.186, -0.177],
                                                [-0.256, 0],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.706, -0.061],
                                                [-1.551, -0.715],
                                                [-0.096, -0.099],
                                                [-0.128, -0.054],
                                                [-0.138, 0],
                                                [-0.127, 0.054],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.001],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.265, 0],
                                                [-0.188, 0.188],
                                                [0, 0],
                                                [0, 0.265],
                                                [0.187, 0.188],
                                                [0, 0],
                                                [0.265, 0],
                                                [0.188, -0.188],
                                                [0, 0],
                                                [0, -0.265],
                                                [-0.187, -0.188]
                                            ],
                                            "v": [
                                                [61, 4.5],
                                                [52.144, 0.985],
                                                [51.454, 0.71],
                                                [50.765, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.084, 0.096],
                                                [31.681, 0.015],
                                                [31.279, 0.096],
                                                [30.941, 0.328],
                                                [26.636, 3.412],
                                                [21.455, 4.501],
                                                [16.273, 3.412],
                                                [11.968, 0.328],
                                                [11.637, 0.088],
                                                [11.237, 0],
                                                [10.835, 0.08],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.293, 4.793],
                                                [0, 5.5],
                                                [0, 15.5],
                                                [0.293, 16.208],
                                                [1, 16.5],
                                                [61, 16.5],
                                                [61.707, 16.208],
                                                [62, 15.5],
                                                [62, 5.5],
                                                [61.707, 4.793]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 21",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 8,
                    "ty": 4,
                    "nm": "Path 20",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [60.5, -14.929, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [-1.259, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.698, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.509, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.377, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.046],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [3.295, 0.014],
                                                [1.634, 0.718],
                                                [1.204, 1.317],
                                                [0.128, 0.056],
                                                [0.14, 0],
                                                [0.127, -0.056],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0],
                                                [-0.338, 0.004]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.217],
                                                [0, 0],
                                                [1.034, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.366, 0],
                                                [1.25, -0.549],
                                                [0.377, -0.409],
                                                [0.51, -0.223],
                                                [0.556, 0],
                                                [0.509, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.047],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-2.388, 2.27],
                                                [-1.785, 0.003],
                                                [-1.634, -0.718],
                                                [-0.094, -0.103],
                                                [-0.127, -0.056],
                                                [-0.139, 0],
                                                [-0.128, 0.056],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.056],
                                                [-0.138, -0.003],
                                                [-0.128, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.12, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.679, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.49],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [41.909, 4.5],
                                                [36.725, 3.416],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.681, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.455, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.834, 0.078],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642],
                                                [1, 16.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 20",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 9,
                    "ty": 4,
                    "nm": "Path 19",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [60.5, 0.071, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.338, 0.004],
                                                [-1.259, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.698, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.509, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.377, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.047],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [1.598, -0.602],
                                                [1.706, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.128, 0.057],
                                                [0.14, 0],
                                                [0.127, -0.057],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.128, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.218],
                                                [0, 0],
                                                [1.034, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.366, 0],
                                                [1.25, -0.549],
                                                [0.377, -0.409],
                                                [0.51, -0.223],
                                                [0.556, 0],
                                                [0.509, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.046],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.707, -0.061],
                                                [-1.551, -0.715],
                                                [-0.094, -0.103],
                                                [-0.127, -0.057],
                                                [-0.139, 0],
                                                [-0.128, 0.057],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.003],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.12, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.679, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.491],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.681, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.455, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.833, 0.077],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 19",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 10,
                    "ty": 4,
                    "nm": "Path 18",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [1.5, 15, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.25, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.265, 0],
                                                [2.388, 2.27],
                                                [0.257, 0],
                                                [0.186, -0.177],
                                                [1.598, -0.602],
                                                [1.707, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.127, 0.054],
                                                [0.139, 0],
                                                [0.128, -0.054],
                                                [0.096, -0.099],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.057],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.095, -0.1],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.187, -0.188],
                                                [0, -0.265],
                                                [0, 0],
                                                [-0.188, -0.188],
                                                [-0.265, 0],
                                                [0, 0],
                                                [-0.187, 0.188],
                                                [0, 0.265],
                                                [0, 0],
                                                [0.188, 0.188]
                                            ],
                                            "o": [
                                                [-3.295, 0.014],
                                                [-0.186, -0.177],
                                                [-0.256, 0],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.706, -0.061],
                                                [-1.551, -0.715],
                                                [-0.096, -0.099],
                                                [-0.128, -0.054],
                                                [-0.138, 0],
                                                [-0.127, 0.054],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.001],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.265, 0],
                                                [-0.188, 0.188],
                                                [0, 0],
                                                [0, 0.265],
                                                [0.187, 0.188],
                                                [0, 0],
                                                [0.265, 0],
                                                [0.188, -0.188],
                                                [0, 0],
                                                [0, -0.265],
                                                [-0.187, -0.188]
                                            ],
                                            "v": [
                                                [61, 4.5],
                                                [52.144, 0.985],
                                                [51.454, 0.71],
                                                [50.765, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.084, 0.096],
                                                [31.681, 0.015],
                                                [31.279, 0.096],
                                                [30.941, 0.328],
                                                [26.636, 3.412],
                                                [21.455, 4.501],
                                                [16.273, 3.412],
                                                [11.968, 0.328],
                                                [11.637, 0.088],
                                                [11.237, 0],
                                                [10.835, 0.08],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.293, 4.793],
                                                [0, 5.5],
                                                [0, 15.5],
                                                [0.293, 16.208],
                                                [1, 16.5],
                                                [61, 16.5],
                                                [61.707, 16.208],
                                                [62, 15.5],
                                                [62, 5.5],
                                                [61.707, 4.793]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 18",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 11,
                    "ty": 4,
                    "nm": "Path 17",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [1.5, -14.929, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [-1.259, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.698, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.509, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.377, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.046],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [3.295, 0.014],
                                                [1.634, 0.718],
                                                [1.204, 1.317],
                                                [0.128, 0.056],
                                                [0.14, 0],
                                                [0.127, -0.056],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0],
                                                [-0.338, 0.004]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.217],
                                                [0, 0],
                                                [1.034, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.366, 0],
                                                [1.25, -0.549],
                                                [0.377, -0.409],
                                                [0.51, -0.223],
                                                [0.556, 0],
                                                [0.509, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.047],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-2.388, 2.27],
                                                [-1.785, 0.003],
                                                [-1.634, -0.718],
                                                [-0.094, -0.103],
                                                [-0.127, -0.056],
                                                [-0.139, 0],
                                                [-0.128, 0.056],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.056],
                                                [-0.138, -0.003],
                                                [-0.128, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.12, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.679, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.49],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [41.909, 4.5],
                                                [36.725, 3.416],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.681, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.455, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.834, 0.078],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642],
                                                [1, 16.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 17",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 12,
                    "ty": 4,
                    "nm": "Path 16",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [1.5, 0.071, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.338, 0.004],
                                                [-1.259, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.698, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.509, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.377, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.047],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [1.598, -0.602],
                                                [1.706, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.128, 0.057],
                                                [0.14, 0],
                                                [0.127, -0.057],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.128, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.218],
                                                [0, 0],
                                                [1.034, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.366, 0],
                                                [1.25, -0.549],
                                                [0.377, -0.409],
                                                [0.51, -0.223],
                                                [0.556, 0],
                                                [0.509, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.046],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.707, -0.061],
                                                [-1.551, -0.715],
                                                [-0.094, -0.103],
                                                [-0.127, -0.057],
                                                [-0.139, 0],
                                                [-0.128, 0.057],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.785, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.003],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.12, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.679, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.491],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.681, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.455, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.833, 0.077],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 16",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 13,
                    "ty": 4,
                    "nm": "Path 15",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-59.5, 15, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.25, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.265, 0],
                                                [2.388, 2.27],
                                                [0.257, 0],
                                                [0.186, -0.177],
                                                [1.598, -0.602],
                                                [1.707, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.127, 0.054],
                                                [0.138, 0],
                                                [0.127, -0.054],
                                                [0.096, -0.099],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.057],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.095, -0.1],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.188, -0.188],
                                                [0, -0.265],
                                                [0, 0],
                                                [-0.188, -0.188],
                                                [-0.265, 0],
                                                [0, 0],
                                                [-0.187, 0.188],
                                                [0, 0.265],
                                                [0, 0],
                                                [0.188, 0.188]
                                            ],
                                            "o": [
                                                [-3.295, 0.014],
                                                [-0.186, -0.177],
                                                [-0.256, 0],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.706, -0.061],
                                                [-1.551, -0.715],
                                                [-0.096, -0.099],
                                                [-0.127, -0.054],
                                                [-0.138, 0],
                                                [-0.127, 0.054],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.784, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.001],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.265, 0],
                                                [-0.188, 0.188],
                                                [0, 0],
                                                [0, 0.265],
                                                [0.188, 0.188],
                                                [0, 0],
                                                [0.265, 0],
                                                [0.188, -0.188],
                                                [0, 0],
                                                [0, -0.265],
                                                [-0.187, -0.188]
                                            ],
                                            "v": [
                                                [61, 4.5],
                                                [52.144, 0.985],
                                                [51.454, 0.71],
                                                [50.765, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.084, 0.096],
                                                [31.682, 0.015],
                                                [31.279, 0.096],
                                                [30.941, 0.328],
                                                [26.636, 3.412],
                                                [21.454, 4.501],
                                                [16.273, 3.412],
                                                [11.968, 0.328],
                                                [11.637, 0.088],
                                                [11.237, 0],
                                                [10.835, 0.08],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.293, 4.793],
                                                [0, 5.5],
                                                [0, 15.5],
                                                [0.293, 16.208],
                                                [1, 16.5],
                                                [61, 16.5],
                                                [61.707, 16.208],
                                                [62, 15.5],
                                                [62, 5.5],
                                                [61.707, 4.793]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 15",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 14,
                    "ty": 4,
                    "nm": "Path 14",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-59.5, -14.929, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [-1.26, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.697, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.51, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.378, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.046],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [3.295, 0.014],
                                                [1.634, 0.718],
                                                [1.204, 1.317],
                                                [0.128, 0.056],
                                                [0.139, 0],
                                                [0.128, -0.056],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0],
                                                [-0.338, 0.004]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.217],
                                                [0, 0],
                                                [1.035, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.365, 0],
                                                [1.25, -0.549],
                                                [0.378, -0.409],
                                                [0.51, -0.223],
                                                [0.557, 0],
                                                [0.51, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.047],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-2.388, 2.27],
                                                [-1.785, 0.003],
                                                [-1.634, -0.718],
                                                [-0.094, -0.103],
                                                [-0.128, -0.056],
                                                [-0.14, 0],
                                                [-0.128, 0.056],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.784, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.056],
                                                [-0.138, -0.003],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.121, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.452, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.678, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.49],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [41.909, 4.5],
                                                [36.725, 3.416],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.682, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.454, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.834, 0.078],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642],
                                                [1, 16.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 14",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 15,
                    "ty": 4,
                    "nm": "Path 13",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-59.5, 0.071, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.338, 0.004],
                                                [-1.26, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.697, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.51, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.378, -0.409],
                                                [-1.188, -0.546],
                                                [-1.306, -0.047],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.027, 0],
                                                [-0.744, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.048, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [1.598, -0.602],
                                                [1.706, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.128, 0.057],
                                                [0.139, 0],
                                                [0.128, -0.057],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.218],
                                                [0, 0],
                                                [1.035, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.365, 0],
                                                [1.25, -0.549],
                                                [0.378, -0.409],
                                                [0.51, -0.223],
                                                [0.557, 0],
                                                [0.51, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.046],
                                                [1.223, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.092, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.257, -0.001],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.707, -0.061],
                                                [-1.551, -0.715],
                                                [-0.094, -0.103],
                                                [-0.128, -0.057],
                                                [-0.14, 0],
                                                [-0.128, 0.057],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.784, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.003],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.121, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.452, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.678, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.491],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.682, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.454, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.834, 0.077],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 13",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 16,
                    "ty": 4,
                    "nm": "Path 12",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-120.5, 15, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.25, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.265, 0],
                                                [2.388, 2.27],
                                                [0.257, 0],
                                                [0.186, -0.177],
                                                [1.598, -0.602],
                                                [1.707, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.127, 0.054],
                                                [0.138, 0],
                                                [0.127, -0.054],
                                                [0.096, -0.099],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.057],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.095, -0.1],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.188, -0.188],
                                                [0, -0.265],
                                                [0, 0],
                                                [-0.188, -0.188],
                                                [-0.265, 0],
                                                [0, 0],
                                                [-0.188, 0.188],
                                                [0, 0.265],
                                                [0, 0],
                                                [0.188, 0.188]
                                            ],
                                            "o": [
                                                [-3.295, 0.014],
                                                [-0.186, -0.177],
                                                [-0.257, 0],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.706, -0.061],
                                                [-1.551, -0.715],
                                                [-0.096, -0.099],
                                                [-0.127, -0.054],
                                                [-0.138, 0],
                                                [-0.127, 0.054],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.784, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.001],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.265, 0],
                                                [-0.188, 0.188],
                                                [0, 0],
                                                [0, 0.265],
                                                [0.188, 0.188],
                                                [0, 0],
                                                [0.265, 0],
                                                [0.188, -0.188],
                                                [0, 0],
                                                [0, -0.265],
                                                [-0.188, -0.188]
                                            ],
                                            "v": [
                                                [61, 4.5],
                                                [52.144, 0.985],
                                                [51.454, 0.71],
                                                [50.765, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.084, 0.096],
                                                [31.682, 0.015],
                                                [31.279, 0.096],
                                                [30.941, 0.328],
                                                [26.636, 3.412],
                                                [21.454, 4.501],
                                                [16.273, 3.412],
                                                [11.968, 0.328],
                                                [11.637, 0.088],
                                                [11.237, 0],
                                                [10.835, 0.08],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.293, 4.793],
                                                [0, 5.5],
                                                [0, 15.5],
                                                [0.293, 16.208],
                                                [1, 16.5],
                                                [61, 16.5],
                                                [61.707, 16.208],
                                                [62, 15.5],
                                                [62, 5.5],
                                                [61.707, 4.793]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 12",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 17,
                    "ty": 4,
                    "nm": "Path 11",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-120.5, -14.929, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [-1.26, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.697, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.51, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.378, -0.409],
                                                [-1.188, -0.546],
                                                [-1.307, -0.046],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.026, 0],
                                                [-0.743, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.049, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [3.294, 0.014],
                                                [1.634, 0.718],
                                                [1.204, 1.317],
                                                [0.128, 0.056],
                                                [0.139, 0],
                                                [0.128, -0.056],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0],
                                                [-0.338, 0.004]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.217],
                                                [0, 0],
                                                [1.035, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.365, 0],
                                                [1.25, -0.549],
                                                [0.378, -0.409],
                                                [0.51, -0.223],
                                                [0.557, 0],
                                                [0.51, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.047],
                                                [1.224, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.091, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.258, -0.001],
                                                [-2.388, 2.27],
                                                [-1.785, 0.003],
                                                [-1.634, -0.718],
                                                [-0.094, -0.103],
                                                [-0.128, -0.056],
                                                [-0.139, 0],
                                                [-0.128, 0.056],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.784, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.056],
                                                [-0.138, -0.003],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.121, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.678, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.49],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [41.909, 4.5],
                                                [36.725, 3.416],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.682, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.454, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.834, 0.078],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642],
                                                [1, 16.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 11",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 18,
                    "ty": 4,
                    "nm": "Path 10",
                    "parent": 3,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-120.5, 0.071, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [31, 8.321, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.338, 0.004],
                                                [-1.26, 0.558],
                                                [-0.925, 1.021],
                                                [-0.488, 0.217],
                                                [-0.534, 0.007],
                                                [0, 0],
                                                [-0.697, -0.767],
                                                [-1.25, -0.549],
                                                [-1.365, 0],
                                                [-1.25, 0.549],
                                                [-0.925, 1.005],
                                                [-0.51, 0.223],
                                                [-0.557, 0],
                                                [-0.51, -0.223],
                                                [-0.378, -0.409],
                                                [-1.188, -0.546],
                                                [-1.307, -0.047],
                                                [-1.224, 0.46],
                                                [-0.952, 0.896],
                                                [-1.026, 0],
                                                [-0.743, -0.707],
                                                [-2.527, 0.013],
                                                [-0.326, -0.09],
                                                [0, 0],
                                                [0.049, 0.121],
                                                [0.091, 0.093],
                                                [0.12, 0.051],
                                                [0.13, 0.001],
                                                [2.393, 2.27],
                                                [0.258, 0.001],
                                                [0.188, -0.176],
                                                [1.598, -0.602],
                                                [1.706, 0.061],
                                                [1.551, 0.715],
                                                [1.155, 1.258],
                                                [0.128, 0.057],
                                                [0.139, 0],
                                                [0.128, -0.057],
                                                [0.094, -0.103],
                                                [1.633, -0.718],
                                                [1.784, 0],
                                                [1.633, 0.718],
                                                [1.206, 1.315],
                                                [0.126, 0.056],
                                                [0.138, 0.001],
                                                [0.127, -0.054],
                                                [0.093, -0.102],
                                                [1.636, -0.721],
                                                [1.788, 0.005],
                                                [0.121, -0.047],
                                                [0.093, -0.09],
                                                [0.051, -0.119],
                                                [0.001, -0.129],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [1.378, 0.001],
                                                [1.26, -0.558],
                                                [0.362, -0.393],
                                                [0.488, -0.218],
                                                [0, 0],
                                                [1.035, 0.067],
                                                [0.925, 1.005],
                                                [1.25, 0.549],
                                                [1.365, 0],
                                                [1.25, -0.549],
                                                [0.378, -0.409],
                                                [0.51, -0.223],
                                                [0.557, 0],
                                                [0.51, 0.223],
                                                [0.886, 0.961],
                                                [1.188, 0.546],
                                                [1.307, 0.046],
                                                [1.224, -0.46],
                                                [0.744, -0.707],
                                                [1.026, 0],
                                                [1.833, 1.74],
                                                [0.338, 0.004],
                                                [0, 0],
                                                [0.001, -0.13],
                                                [-0.049, -0.121],
                                                [-0.091, -0.093],
                                                [-0.12, -0.051],
                                                [-3.298, 0.018],
                                                [-0.187, -0.177],
                                                [-0.258, -0.001],
                                                [-1.242, 1.172],
                                                [-1.598, 0.602],
                                                [-1.706, -0.061],
                                                [-1.551, -0.715],
                                                [-0.094, -0.103],
                                                [-0.128, -0.057],
                                                [-0.139, 0],
                                                [-0.128, 0.057],
                                                [-1.206, 1.315],
                                                [-1.633, 0.718],
                                                [-1.784, 0],
                                                [-1.633, -0.718],
                                                [-0.093, -0.102],
                                                [-0.126, -0.057],
                                                [-0.138, -0.003],
                                                [-0.127, 0.054],
                                                [-1.203, 1.323],
                                                [-1.636, 0.721],
                                                [-0.129, -0.004],
                                                [-0.121, 0.047],
                                                [-0.093, 0.09],
                                                [-0.051, 0.119],
                                                [0, 0],
                                                [0.326, -0.09]
                                            ],
                                            "v": [
                                                [1, 16.5],
                                                [5, 15.654],
                                                [8.314, 13.259],
                                                [9.603, 12.334],
                                                [11.153, 11.994],
                                                [11.487, 12.009],
                                                [14.187, 13.309],
                                                [17.485, 15.664],
                                                [21.451, 16.496],
                                                [25.418, 15.664],
                                                [28.716, 13.309],
                                                [30.061, 12.35],
                                                [31.678, 12.012],
                                                [33.296, 12.35],
                                                [34.641, 13.309],
                                                [37.783, 15.593],
                                                [41.562, 16.491],
                                                [45.396, 15.864],
                                                [48.692, 13.809],
                                                [51.449, 12.708],
                                                [54.205, 13.809],
                                                [61, 16.5],
                                                [62, 16.642],
                                                [62, 5.5],
                                                [61.929, 5.12],
                                                [61.717, 4.796],
                                                [61.397, 4.579],
                                                [61.018, 4.5],
                                                [52.15, 0.991],
                                                [51.458, 0.714],
                                                [50.764, 0.985],
                                                [46.462, 3.673],
                                                [41.456, 4.492],
                                                [36.521, 3.317],
                                                [32.422, 0.328],
                                                [32.086, 0.086],
                                                [31.682, 0],
                                                [31.277, 0.086],
                                                [30.941, 0.328],
                                                [26.636, 3.411],
                                                [21.454, 4.5],
                                                [16.273, 3.411],
                                                [11.968, 0.328],
                                                [11.636, 0.088],
                                                [11.236, 0],
                                                [10.833, 0.077],
                                                [10.499, 0.314],
                                                [6.193, 3.414],
                                                [1, 4.5],
                                                [0.621, 4.566],
                                                [0.297, 4.773],
                                                [0.079, 5.089],
                                                [0, 5.465],
                                                [0, 16.642]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 10",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 19,
                    "ty": 4,
                    "nm": "Boat",
                    "parent": 1,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": {
                            "a": 1,
                            "k": [
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 0,
                                    "s": [-18.5, 0.25, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 32,
                                    "s": [-18.5, 2.917, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 73,
                                    "s": [-18.5, 0.2, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 119,
                                    "s": [-18.5, 2.917, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 163,
                                    "s": [-18.5, 0.147, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 212,
                                    "s": [-18.5, 2.917, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 245,
                                    "s": [-18.5, 0.112, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 280,
                                    "s": [-18.5, 2.917, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 312,
                                    "s": [-18.5, 0.917, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 353,
                                    "s": [-18.5, 2.917, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 399,
                                    "s": [-18.5, 0.873, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 443,
                                    "s": [-18.5, 2.917, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 492,
                                    "s": [-18.5, 0.83, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                {
                                    "i": { "x": 0.833, "y": 0.833 },
                                    "o": { "x": 0.333, "y": 0 },
                                    "t": 550,
                                    "s": [-18.5, 0.112, 0],
                                    "to": [0, 0, 0],
                                    "ti": [0, 0, 0]
                                },
                                { "t": 594, "s": [-18.5, 0.25, 0] }
                            ],
                            "ix": 2,
                            "l": 2
                        },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "rc",
                            "d": 1,
                            "s": { "a": 0, "k": [42, 29], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 4 },
                            "nm": "Rectangle Path 1",
                            "mn": "ADBE Vector Shape - Rect",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 20,
                    "ty": 4,
                    "nm": "Path 9",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-1.774, 11.231, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [2.032, 1.287, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [-3.965, -0.721],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [4.064, 2.574],
                                                [0, 0]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0.988235294118, 0.729411764706, 0.188235294118, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 1, "ix": 5 },
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 9",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 21,
                    "ty": 4,
                    "nm": "Path 8",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-8.287, 3.572, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [2.245, 0.864, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [4.03, -0.071],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [0, 0.002],
                                                [4.49, 1.729]
                                            ],
                                            "c": false
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "st",
                                    "c": { "a": 0, "k": [0.988235294118, 0.729411764706, 0.188235294118, 1], "ix": 3 },
                                    "o": { "a": 0, "k": 100, "ix": 4 },
                                    "w": { "a": 0, "k": 1, "ix": 5 },
                                    "lc": 2,
                                    "lj": 1,
                                    "ml": 4,
                                    "bm": 0,
                                    "nm": "Stroke 1",
                                    "mn": "ADBE Vector Graphic - Stroke",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 8",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 22,
                    "ty": 4,
                    "nm": "Path 7",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [11.5, 7, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [1.5, 1.5, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.828, 0],
                                                [0, 0.828],
                                                [0.828, 0],
                                                [0, -0.828]
                                            ],
                                            "o": [
                                                [0.828, 0],
                                                [0, -0.828],
                                                [-0.828, 0],
                                                [0, 0.828]
                                            ],
                                            "v": [
                                                [1.5, 3],
                                                [3, 1.5],
                                                [1.5, 0],
                                                [0, 1.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 7",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 23,
                    "ty": 4,
                    "nm": "Path 6",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [3.5, 7, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [1.5, 1.5, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.828, 0],
                                                [0, 0.828],
                                                [0.828, 0],
                                                [0, -0.828]
                                            ],
                                            "o": [
                                                [0.828, 0],
                                                [0, -0.828],
                                                [-0.828, 0],
                                                [0, 0.828]
                                            ],
                                            "v": [
                                                [1.5, 3],
                                                [3, 1.5],
                                                [1.5, 0],
                                                [0, 1.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 6",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 24,
                    "ty": 4,
                    "nm": "Path 5",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-4.5, 7, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [1.5, 1.5, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.828, 0],
                                                [0, 0.828],
                                                [0.828, 0],
                                                [0, -0.828]
                                            ],
                                            "o": [
                                                [0.828, 0],
                                                [0, -0.828],
                                                [-0.828, 0],
                                                [0, 0.828]
                                            ],
                                            "v": [
                                                [1.5, 3],
                                                [3, 1.5],
                                                [1.5, 0],
                                                [0, 1.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 5",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 25,
                    "ty": 4,
                    "nm": "Path 4",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-11.5, 7, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [1.5, 1.5, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [-0.828, 0],
                                                [0, 0.828],
                                                [0.828, 0],
                                                [0, -0.828]
                                            ],
                                            "o": [
                                                [0.828, 0],
                                                [0, -0.828],
                                                [-0.828, 0],
                                                [0, 0.828]
                                            ],
                                            "v": [
                                                [1.5, 3],
                                                [3, 1.5],
                                                [1.5, 0],
                                                [0, 1.5]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 4",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 26,
                    "ty": 4,
                    "nm": "Path 3",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [0, 7.5, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [21, 7, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.379, 0],
                                                [0, 0],
                                                [0.136, 0.408],
                                                [0, 0],
                                                [-0.188, 0.261],
                                                [-0.321, 0],
                                                [0, 0],
                                                [-0.182, -0.294],
                                                [0.155, -0.31],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-0.431, 0],
                                                [0, 0],
                                                [-0.102, -0.305],
                                                [0.188, -0.261],
                                                [0, 0],
                                                [0.347, 0],
                                                [0.182, 0.295],
                                                [0, 0],
                                                [-0.169, 0.339]
                                            ],
                                            "v": [
                                                [35, 14],
                                                [2, 14],
                                                [1.051, 13.316],
                                                [0.051, 1.316],
                                                [0.189, 0.415],
                                                [1, 0],
                                                [41, 0],
                                                [41.85, 0.474],
                                                [41.895, 1.447],
                                                [35.895, 13.447]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0.764705882353, 0.070588235294, 0.188235294118, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 3",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 27,
                    "ty": 4,
                    "nm": "Path 2",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-2, -2.5, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [15, 5, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.347, 0],
                                                [0, 0],
                                                [0, 0.552],
                                                [0, 0],
                                                [-0.552, 0],
                                                [0, 0],
                                                [-0.169, -0.339],
                                                [0, 0],
                                                [0.182, -0.295]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-0.552, 0],
                                                [0, 0],
                                                [0, -0.552],
                                                [0, 0],
                                                [0.379, 0],
                                                [0, 0],
                                                [0.155, 0.31],
                                                [-0.182, 0.294]
                                            ],
                                            "v": [
                                                [29, 10],
                                                [1, 10],
                                                [0, 9],
                                                [1, 1],
                                                [2, 0],
                                                [25, 0],
                                                [25.895, 0.553],
                                                [29.895, 8.553],
                                                [29.851, 9.526]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 2",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 28,
                    "ty": 4,
                    "nm": "Path 1",
                    "parent": 19,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 100, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-8, -10.5, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [5, 4, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0.552, 0],
                                                [0, 0],
                                                [0, -0.552],
                                                [0, 0],
                                                [-0.552, 0],
                                                [0, 0],
                                                [0, 0.552],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [-0.552, 0],
                                                [0, 0],
                                                [0, 0.552],
                                                [0, 0],
                                                [0.552, 0],
                                                [0, 0],
                                                [0, -0.552]
                                            ],
                                            "v": [
                                                [7, 0],
                                                [1, 0],
                                                [0, 1],
                                                [0, 7],
                                                [1, 8],
                                                [9, 8],
                                                [10, 7],
                                                [8, 1]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0.349019607843, 0.349019607843, 0.349019607843, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Path 1",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                },
                {
                    "ddd": 0,
                    "ind": 29,
                    "ty": 4,
                    "nm": "Rectangle 1",
                    "parent": 1,
                    "sr": 1,
                    "ks": {
                        "o": { "a": 0, "k": 16.335, "ix": 11 },
                        "r": { "a": 0, "k": 0, "ix": 10 },
                        "p": { "a": 0, "k": [-6.5, -6.25, 0], "ix": 2, "l": 2 },
                        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
                    },
                    "ao": 0,
                    "shapes": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": { "a": 0, "k": [142, 94], "ix": 2 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "op",
                                    "nm": "Offset Paths 1",
                                    "a": { "a": 0, "k": -0.5, "ix": 1 },
                                    "lj": 1,
                                    "ml": { "a": 0, "k": 4, "ix": 3 },
                                    "ix": 3,
                                    "mn": "ADBE Vector Filter - Offset",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Rectangle 1 Stroke",
                            "np": 3,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ty": "rc",
                                    "d": 1,
                                    "s": { "a": 0, "k": [142, 94], "ix": 2 },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 4 },
                                    "nm": "Rectangle Path 1",
                                    "mn": "ADBE Vector Shape - Rect",
                                    "hd": false
                                },
                                {
                                    "ty": "fl",
                                    "c": { "a": 0, "k": [0.050980392157, 0.623529411765, 0.717647058824, 1], "ix": 4 },
                                    "o": { "a": 0, "k": 100, "ix": 5 },
                                    "r": 1,
                                    "bm": 0,
                                    "nm": "Fill 1",
                                    "mn": "ADBE Vector Graphic - Fill",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [0, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Rectangle 1 Fill",
                            "np": 2,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        }
                    ],
                    "ip": 0,
                    "op": 605,
                    "st": 0,
                    "bm": 0
                }
            ]
        }
    ],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 0,
            "nm": "Mask",
            "refId": "comp_0",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [53.5, 53.5, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [53.5, 53.5, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "hasMask": true,
            "masksProperties": [
                {
                    "inv": false,
                    "mode": "f",
                    "pt": {
                        "a": 0,
                        "k": {
                            "i": [
                                [29.527, 0],
                                [0, -29.527],
                                [-29.527, 0],
                                [0, 29.527]
                            ],
                            "o": [
                                [-29.527, 0],
                                [0, 29.527],
                                [29.527, 0],
                                [0, -29.527]
                            ],
                            "v": [
                                [53.5, 0],
                                [0, 53.5],
                                [53.5, 107],
                                [107, 53.5]
                            ],
                            "c": true
                        },
                        "ix": 1
                    },
                    "o": { "a": 0, "k": 100, "ix": 3 },
                    "x": { "a": 0, "k": 0, "ix": 4 },
                    "nm": "Mask 1"
                }
            ],
            "w": 107,
            "h": 107,
            "ip": 0,
            "op": 605,
            "st": 0,
            "bm": 0
        }
    ],
    "markers": []
};
//# sourceMappingURL=lottieLoaderjson.js.map